import React, { Fragment } from 'react';
import { observer, inject } from 'mobx-react';
import {
  withStyles,
  Grid,
  DialogActions,
  Dialog,
  Button,
  DialogContent,
  DialogTitle,
  Paper,
  InputBase,
  Divider,
  IconButton,
  TextField,
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  InputAdornment,
  MenuList,
  MenuItem,
  Typography,
} from '@material-ui/core';
import FormHelperText from '@material-ui/core/FormHelperText';
import SearchIcon from '@material-ui/icons/Search';
import moment from 'moment';
import Swal from 'sweetalert2';
import 'antd/dist/antd.css';
import './styles/patientview.css';
import './styles/dialog.css';
import { withTranslation } from 'react-i18next';
import config from '../../config';
import { clearLocalStorage } from '../../utils/common';

import InputMask from 'react-input-mask';

class Patient extends React.PureComponent {
  state = {
    date: '',
    searchText: '',
    errorField: {
      hn: false,
      firstname: false,
      lastname: false,
      firstnameEn: false,
      lastnameEn: false,
      dob: false,
      searchText: false,
    },
    errorReason: {
      dob: '',
      searchText: '',
    },
    open: false,
  };

  handleSearchHN = async () => {
    const { t } = this.props;
    let { data } = this.props.patient.toJS();
    // const { user } = this.props.dashboard.toJS();
    this.props.patient.changeData('hn', !data.reset ? this.state.searchText : '');
    try {
      const patients = await this.props.patient.getPatientByHN();
      if (patients && patients.status === 'ADMITTED') {
        Swal.fire({
          html: `<h4>${t('patient_is_admitted')} `,
          confirmButtonText: `${t('ok')}`,
          type: 'warning',
          // width: 400,
          customClass: {
            container: 'my-swal',
          },
        }).then((result) => {
          // this.setState({
          //   searchText: ''
          // });
          // if (result.value) {
          //   this.props.patient.changeData('hn', '');
          // }
          this.props.patient.setData({
            search: false,
            name: '',
            patient: {
              hn: '',
              firstname: '',
              lastname: '',
              firstnameEn: '',
              lastnameEn: '',
              gender: 'M',
              dob: '00/00/0000',
              weight: '',
              height: '',
            },
          });
        });
      }
    } catch (error) {
      // console.log('error', error);
      Swal.fire({
        html: `<h4>${t('patient_not_found')}`,
        width: 400,
        showCancelButton: true,
        reverseButtons: true,
        cancelButtonText: `${t('search_again')}`,
        cancelButtonColor: '#e0e0e0',
        confirmButtonText: `${t('create_new')}`,
        confirmButtonColor: '#3085d6',
        customClass: {
          container: 'my-swal',
        },
      }).then(async (result) => {
        if (result.value) {
          this.props.patient.changeData('hn', this.state.searchText);
          this.setState({
            searchText: '',
            errorField: {
              searchText: false,
            },
            errorReason: {
              searchText: '',
            },
          });
        }
      });
    }
  };

  handleSearch = async () => {
    const { t, state } = this.props;
    if (this.state.searchText) {
      const tenantIds = state.dialogPatient && state.dialogPatient.tenantId ? [state.dialogPatient.tenantId] : null;
      try {
        await this.props.patient.getPatientBySearch(this.state.searchText, tenantIds);
        this.setState({ open: true });
      } catch (error) {
        Swal.fire({
          html: `<h4>${t('patient_not_found')}`,
          width: 400,
          confirmButtonText: `${t('ok')}`,
          customClass: {
            container: 'my-swal',
          },
        }).then(async (result) => {
          if (result.value) {
            this.setState({
              searchText: '',
              errorField: {
                searchText: false,
              },
              errorReason: {
                searchText: '',
              },
            });
          }
        });
      }
    }
  };

  handleSelect = (patient) => {
    const { t } = this.props;
    if (patient && patient.status === 'ADMITTED') {
      Swal.fire({
        html: `<h4>${t('patient_is_admitted')} `,
        confirmButtonText: `${t('ok')}`,
        type: 'warning',
        customClass: {
          container: 'my-swal',
        },
      }).then((result) => {
        this.props.patient.setData({
          search: false,
          name: '',
          patient: {
            hn: patient.hn,
            firstname: patient.firstname ? patient.firstname : patient.firstnameEn,
            lastname: '',
            firstnameEn: '',
            lastnameEn: '',
            gender: 'M',
            dob: '00/00/0000',
            weight: '',
            height: '',
          },
        });
      });
    } else {
      if (patient.id) {
        let newDate = patient.dob ? patient.dob.split('-') : null;
        patient.dob = newDate ? `${newDate[2]}/${newDate[1]}/${+newDate[0] + 543}` : null;
        patient.firstname = patient.firstname ? patient.firstname : patient.firstnameEn;
        patient.lastname = patient.lastname ? patient.lastname : patient.lastnameEn;
        patient.firstnameEn = patient.firstnameEn ? patient.firstnameEn : patient.firstname;
        patient.lastnameEn = patient.lastnameEn ? patient.lastnameEn : patient.lastname;
        patient.gender = patient.gender ? patient.gender.toUpperCase() : patient.gender;

        this.props.patient.setData({
          search: true,
          patient,
        });
      }
      this.setState({
        searchText: '',
        open: false,
      });
    }
  };

  onSeachInputChange = (value) => {
    this.props.patient.setReset(false);
    this.setState({ searchText: value, open: false });
  };

  validateInputChange = (key, value) => {
    let flag = true;
    if (value) {
      const patt = /^[0-9]+((\.)?)+([0-9]{1,2})?$/;
      flag = patt.test(value);
    }

    if (flag) {
      this.props.patient.changeData(key, value);
    }
  };

  onTextChange = (key, value) => {
    this.clearErrorField(key);
    this.props.patient.changeData(key, value);
  };

  clearErrorField(key) {
    if (key === 'hn') {
      this.setState({
        ...this.state,
        errorField: {
          ...this.state.errorField,
          hn: false,
        },
      });
    }
    if (key === 'firstname') {
      this.setState({
        ...this.state,
        errorField: {
          ...this.state.errorField,
          firstname: false,
        },
      });
    }
    if (key === 'lastname') {
      this.setState({
        ...this.state,
        errorField: {
          ...this.state.errorField,
          lastname: false,
        },
      });
    }
    if (key === 'firstnameEn') {
      this.setState({
        ...this.state,
        errorField: {
          ...this.state.errorField,
          firstnameEn: false,
        },
      });
    }
    if (key === 'lastnameEn') {
      this.setState({
        ...this.state,
        errorField: {
          ...this.state.errorField,
          lastnameEn: false,
        },
      });
    }
    if (key === 'dob') {
      this.setState({
        ...this.state,
        errorField: {
          ...this.state.errorField,
          dob: false,
        },
      });
    }
  }

  onTextBlur = (key, value) => {
    const { props, dataBed } = this.props;
    const bed = props.data ? props.data : dataBed;
    let data = value.trim();
    if (key === 'hn' && bed.patient && bed.patient.hn && data !== bed.patient.hn) {
      this.props.patient.setHnStatus(false);
    }
    this.props.patient.changeData(key, data);
  };

  changeInfoData = (e) => {
    let { name, value } = e.target;
    this.props.patient.changeData(name, value);
  };

  validate() {
    const { t } = this.props;
    let { data } = this.props.patient.toJS();
    let newDate = data.patient.dob ? data.patient.dob.split('/') : null;
    const _year = newDate ? +newDate[2] - 543 : '0000';
    const _month = newDate ? newDate[1] : '00';
    const _day = newDate ? newDate[0] : '00';
    data.patient.dob = `${_year}-${_month}-${_day}`;

    const dateNow = new Date();
    const thisYear = dateNow.getUTCFullYear();
    const minYear = thisYear - 120;

    var patternBod = /^([0-9]{4})-([0-9]{2})-([0-9]{2})$/;
    if (
      !data.patient.hn ||
      data.patient.dob === '0000-00-00' ||
      !data.patient.dob ||
      data.patient.dob === '' ||
      data.patient.dob === undefined ||
      !patternBod.test(data.patient.dob) ||
      moment().diff(data.patient.dob, 'days') < 0
    ) {
      let checkHn = !data.patient.hn ? true : false;
      let checkFirstname = false;
      let checkLastname = false;
      if (localStorage.getItem('i18nextLng') && localStorage.getItem('i18nextLng') === 'th-TH') {
        if (!data.patient.firstname || !data.patient.lastname) {
          checkFirstname = !data.patient.firstname ? true : false;
          checkLastname = !data.patient.lastname ? true : false;
        }
      }
      if (localStorage.getItem('i18nextLng') && localStorage.getItem('i18nextLng') === 'en-EN') {
        if (!data.patient.firstnameEn || !data.patient.lastnameEn) {
          checkFirstname = !data.patient.firstnameEn ? true : false;
          checkLastname = !data.patient.firstnameEn ? true : false;
        }
      }
      let checkDob = false;
      let dobErrorReason = '';
      if (
        data.patient.dob === '0000-00-00' ||
        !data.patient.dob ||
        data.patient.dob === '' ||
        data.patient.dob === undefined
      ) {
        checkDob = true;
        dobErrorReason = `${t('required_field')}`;
      } else if (!patternBod.test(data.patient.dob) || moment().diff(data.patient.dob, 'days') < 0) {
        checkDob = true;
        dobErrorReason = `${t('invalid_format')}`;
      }

      this.setState({
        errorField: {
          hn: checkHn,
          firstname: checkFirstname,
          lastname: checkLastname,
          dob: checkDob,
        },
        errorReason: {
          dob: dobErrorReason,
        },
      });
      return false;
    } else if (+_day < 1 || +_day > 31 || +_month < 1 || +_month > 12 || _year > thisYear || _year < minYear) {
      this.setState({
        errorField: {
          dob: true,
        },
        errorReason: {
          dob: `${t('invalid_format')}`,
        },
      });
      return false;
    } else if ((+_month === 4 || +_month === 6 || +_month === 9 || +_month === 11) && +_day === 31) {
      this.setState({
        errorField: {
          dob: true,
        },
        errorReason: {
          dob: `${t('invalid_date')}`,
        },
      });
      return false;
    } else if (+_month === 2) {
      const isleap = _year % 4 === 0 && (_year % 100 !== 0 || _year % 400 === 0);
      if (+_day > 29 || (+_day === 29 && !isleap)) {
        this.setState({
          errorField: {
            dob: true,
          },
          errorReason: {
            dob: `${t('invalid_date')}`,
          },
        });
        return false;
      }
      return true;
    } else {
      this.setState({
        errorField: {
          hn: false,
          firstname: false,
          lastname: false,
          dob: false,
        },
      });
    }
    return true;
  }

  handleSubmit = async () => {
    this.props.patient.setReset(false);
    if (this.validate()) {
      const { props, dataBed, onlyUpdate, state } = this.props;
      let bed = props.data ? props.data : dataBed;
      let { data } = this.props.patient.toJS();
      let newDate = data.patient.dob.split('/');
      data.patient.dob = `${+newDate[2] - 543}-${newDate[1]}-${newDate[0]}`;
      data.patient.age = moment().diff(data.patient.dob, 'years');
      data.patient.tenantId = data.patient.tenantId ? data.patient.tenantId : state.dialogPatient.tenantId;
      data.patient.weight = data.patient.weight ? parseFloat(data.patient.weight).toFixed(2) : '';
      data.patient.height = data.patient.height ? parseFloat(data.patient.height).toFixed(2) : '';

      if (onlyUpdate) {
        this.handleOnlyEditPatient(data);
      } else {
        this.handleUpdate(bed, data);
      }
    }
  };

  handleUpdate = async (bed, data) => {
    const { t } = this.props;
    if (bed && bed.id && bed.patient) {
      // try {
      if (!data.hnStatus) {
        Swal.fire({
          html: `<h4>${config.style.useHN ? t('replace_hn') : t('replace_id')}`,
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: `${t('replace')}`,
          cancelButtonText: `${t('cancel')}`,
          reverseButtons: true,
          customClass: {
            container: 'my-swal',
          },
        }).then(async (result) => {
          if (result.value) {
            try {
              data.patient.warningSetting.outOfArea = 1;
              await this.props.dashboard.patientUpdate(data, bed);
              this.props.handleClose();
            } catch (err) {
              Swal.fire({
                html: `<h4>${config.style.useHN ? t('hn_is_already_in_used') : t('id_is_already_in_used')}`,
                confirmButtonText: `${t('ok')}`,
                type: 'warning',
                customClass: {
                  container: 'my-swal',
                },
              });
            }
          }
        });
      } else {
        try {
          await this.props.dashboard.patientUpdate(data, bed);
          await this.props.setting.getSettingByPatient(data.patient.id);

          this.props.setting.changeData('outOfArea', 1);
          await this.props.setting.settingUpdate();
          this.props.handleClose();
        } catch (error) {
          Swal.fire({
            html: `<h4>${config.style.useHN ? t('hn_is_already_in_used') : t('id_is_already_in_used')}`,
            confirmButtonText: `${t('ok')}`,
            type: 'warning',
            // width: 400,
            customClass: {
              container: 'my-swal',
            },
          });
        }
      }
    } else {
      if (!this.props.data && bed && !bed.id) {
        // automatic create new bed for patient at HOME
        const newBedInfo = {
          bed: '',
          bedType: 1,
          room: 'Home',
          roomType: 9,
        };

        const res = await this.props.bed.createBed(newBedInfo, bed.subGroupId);
        if (res && res.body) {
          const newBed = res.body;
          bed = {
            patient: data.patient,
            id: newBed.id,
            subGroupId: newBed.subGroupId,
          };
        }
      }
      try {
        let result = await this.props.dashboard.patientCreate(data, bed);
        if (result && result.patient.id && data.search) {
          await this.props.setting.getSettingByPatient(result.patient.id);
          this.props.setting.changeData('outOfArea', 1);
          await this.props.setting.settingUpdate();
        }
        this.props.handleClose();
      } catch (error) {
        const message = error.error;
        console.log('message: ', message);
        Swal.fire({
          // html: `<h4>${t('failed_to_admit')}`,
          html: `<h4>${config.style.useHN ? t('hn_is_already_in_used') : t('id_is_already_in_used')}`,
          confirmButtonText: `${t('ok')}`,
          type: 'warning',
          customClass: {
            container: 'my-swal',
          },
        }).then(() => {
          this.props.patient.setData({
            search: false,
            name: '',
            patient: {
              hn: '',
              firstname: '',
              lastname: '',
              firstnameEn: '',
              lastnameEn: '',
              gender: 'M',
              dob: '00/00/0000',
              weight: '',
              height: '',
            },
          });
        });
      }
    }
  };

  handleOnlyEditPatient = async (data) => {
    const { t } = this.props;
    try {
      let result = await this.props.patient.patientUpdate(data.patient);
      if (result.statusCode === 200) {
        const { offset, limit, search, sort, order } = this.props.patient.toJS();
        await this.props.patient.getAllPatients(offset, limit, search, sort, order);
        this.props.handleClose();
      }
    } catch (e) {
      if (e.statusCode === 401) {
        clearLocalStorage();
        window.location.href = '/login';
      } else if (e.statusCode === 400) {
        const msg = e.error.message || t('failed_to_update');
        Swal.fire({ html: `<h4>${msg}`, type: 'error' });
      } else {
        Swal.fire({ html: `<h4>${t('failed_to_update')}`, type: 'error' });
      }
    }
  };

  render() {
    let { state, props, t, dataBed } = this.props;
    const bed = props.data ? props.data : dataBed;
    let { data, searchPatients } = this.props.patient.toJS();
    const bloodGroupList = ['A', 'B', 'AB', 'O'];

    return (
      <Dialog
        open={state.dialogPatient.open}
        onClose={this.props.handleClose}
        aria-labelledby='form-dialog-title'
        maxWidth='sm'
        fullWidth={true}
        PaperProps={{
          style: {
            borderRadius: 8,
          },
        }}
      >
        <DialogTitle id='form-dialog-title' className='header'>
          {/* {!bed || !bed.patient
            ? `${t("admit_patient")}  `
            : `${t("edit_patient_for")} `} */}
          <Grid container style={{ position: 'relative' }}>
            <div>{!bed || !bed.patient ? `${t('admit_patient')}  ` : `${t('edit_patient_for')} `}</div>
            <div className='closeIcon' onClick={this.props.handleClose}>
              <svg width='32' height='32' viewBox='0 0 32 32'>
                <use xlinkHref={`/images/menus-v1.svg#close`} />
              </svg>
            </div>
          </Grid>
        </DialogTitle>
        <DialogContent>
          <Grid container>
            <Grid item xs={12}>
              {(!bed || !bed.patient) && (
                <div className={props.classes.formInput}>
                  <Paper className={`${props.classes.root} searchInput`} elevation={1}>
                    <InputBase
                      className={props.classes.input}
                      placeholder={t('search')}
                      id='SearchHn'
                      label={t('hn')}
                      type='text'
                      inputProps={{ maxLength: 50 }}
                      // onInput={(e) => { e.target.value = e.target.value.replace(/[ก-๙]/g, '') }}
                      value={!data.reset ? this.state.searchText : ''}
                      onChange={(e) => this.onSeachInputChange(e.target.value)}
                      fullWidth
                    />
                    <Divider className={props.classes.divider} />
                    <IconButton className={props.classes.iconButton} aria-label='Search' onClick={this.handleSearch}>
                      <SearchIcon />
                    </IconButton>
                  </Paper>
                  <FormHelperText
                    error={!data.reset ? !this.state.errorField.searchText : true}
                    id='component-error-text'
                  >
                    {this.state.errorReason.searchText}
                  </FormHelperText>
                  <div className={props.classes.positionPaper}>
                    {this.state.open && (
                      <Paper className={`${props.classes.root} searchInput`} style={{ position: 'absolute' }}>
                        <div className={props.classes.patientMenuItem}>
                          <MenuList>
                            {searchPatients.map((patient) => (
                              <MenuItem
                                key={patient.id}
                                onClick={() => this.handleSelect(patient)}
                                disabled={patient.status === 'ADMITTED'}
                              >
                                <Grid container>
                                  <Grid item md={4} xs={4}>
                                    <Typography weight='medium'>{patient.hn}</Typography>
                                  </Grid>
                                  <Grid container item md={6} xs={6}>
                                    <Typography weight='medium'>{patient.firstname}</Typography>
                                    <Typography weight='medium' style={{ marginLeft: 10 }}>
                                      {patient.lastname}
                                    </Typography>
                                  </Grid>
                                  <Grid container item md={2} xs={2}>
                                    <Typography weight='medium'>{patient.status}</Typography>
                                  </Grid>
                                </Grid>
                              </MenuItem>
                            ))}
                          </MenuList>
                        </div>
                      </Paper>
                    )}
                  </div>
                </div>
              )}
            </Grid>
            <Grid item md={12} xs={12}>
              <div className={props.classes.formInput}>
                {data.patient && (
                  <Fragment>
                    <TextField
                      error={!data.reset ? this.state.errorField.hn : false}
                      id='hn'
                      label={config.style.useHN ? t('hn') : t('id_card_number')}
                      className='inputHospitalNumber'
                      value={(data.patient && data.patient.hn) || ''}
                      onChange={(e) => this.onTextChange('hn', e.target.value)}
                      inputProps={{ maxLength: 13 }}
                      onInput={(e) => {
                        e.target.value = e.target.value.replace(/[ก-๙]/g, '');
                      }}
                      onBlur={(e) => this.onTextBlur('hn', e.target.value)}
                      type='text'
                      fullWidth
                    />
                    <FormHelperText
                      error
                      hidden={!data.reset ? !this.state.errorField.hn : true}
                      id='component-error-text'
                    >
                      {t('required_field')}
                    </FormHelperText>
                  </Fragment>
                )}
              </div>
            </Grid>

            <Grid item md={6} xs={12}>
              <div className={props.classes.formInput}>
                {data.patient && (
                  <Fragment>
                    <TextField
                      error={!data.reset ? this.state.errorField.firstname : false}
                      id='firstname'
                      label={t('first_name')}
                      className='inputFirstName'
                      value={
                        (localStorage.getItem('i18nextLng') === 'th-TH'
                          ? data.patient.firstname
                          : data.patient.firstnameEn) || ''
                      }
                      onChange={(e) =>
                        this.onTextChange(
                          localStorage.getItem('i18nextLng') === 'th-TH' ? 'firstname' : 'firstnameEn',
                          e.target.value,
                        )
                      }
                      onBlur={(e) =>
                        this.onTextBlur(
                          localStorage.getItem('i18nextLng') === 'th-TH' ? 'firstname' : 'firstnameEn',
                          e.target.value,
                        )
                      }
                      type='text'
                      fullWidth
                    />
                    <FormHelperText
                      error
                      hidden={!data.reset ? !this.state.errorField.firstname : true}
                      id='component-error-text'
                    >
                      {t('required_field')}
                    </FormHelperText>
                  </Fragment>
                )}
              </div>
            </Grid>
            <Grid item md={6} xs={12}>
              <div className={props.classes.formInput}>
                {data.patient && (
                  <Fragment>
                    <TextField
                      error={!data.reset ? this.state.errorField.lastname : false}
                      id='lastname'
                      label={t('last_name')}
                      className='inputLastName'
                      value={
                        (localStorage.getItem('i18nextLng') === 'th-TH'
                          ? data.patient.lastname
                          : data.patient.lastnameEn) || ''
                      }
                      onChange={(e) =>
                        this.onTextChange(
                          localStorage.getItem('i18nextLng') === 'th-TH' ? 'lastname' : 'lastnameEn',
                          e.target.value,
                        )
                      }
                      onBlur={(e) =>
                        this.onTextBlur(
                          localStorage.getItem('i18nextLng') === 'th-TH' ? 'lastname' : 'lastnameEn',
                          e.target.value,
                        )
                      }
                      type='text'
                      fullWidth
                    />
                    <FormHelperText
                      error
                      hidden={!data.reset ? !this.state.errorField.lastname : true}
                      id='component-error-text'
                    >
                      {t('required_field')}
                    </FormHelperText>
                  </Fragment>
                )}
              </div>
            </Grid>

            <Grid item md={6} xs={12}>
              <FormControl component='fieldset' className={`${props.classes.formControl} genderControl`}>
                <FormLabel component='legend' style={{ fontSize: '0.95rem' }}>
                  {t('gender')}
                </FormLabel>
                {data.patient && (
                  <RadioGroup
                    aria-label='Gender'
                    id='gender'
                    name='gender'
                    className={props.classes.RadioGroup}
                    value={data.patient.gender || 'M'}
                    onChange={(e) => this.changeInfoData(e)}
                    row
                  >
                    <FormControlLabel
                      value={'M'}
                      control={<Radio id='Male' />}
                      label={t('male')}
                      style={{ fontSize: '0.95rem', color: '#6d6d6d' }}
                    />
                    <FormControlLabel
                      value={'F'}
                      control={<Radio id='Female' />}
                      label={t('female')}
                      style={{ fontSize: '0.95rem', color: '#6d6d6d' }}
                    />
                  </RadioGroup>
                )}
              </FormControl>
            </Grid>
            <Grid item md={6} xs={12}>
              <div className={props.classes.formInput} style={{ marginTop: '-14px' }}>
                {data.patient && (
                  <Fragment>
                    {/* <TextField
                      error={!data.reset ? this.state.errorField.dob : false}
                      id="date"
                      label="Birthday (e.g. 15/11/2550)"
                      type="text"
                      // placeholder='dd/mm/yyyy'
                      // defaultValue="2017-05-24"
                      className="birthdayControl"
                      locale='th'
                      value={data.patient.dob === '0000-00-00' ? '' : data.patient.dob }
                      onChange={e => this.onTextChange('dob', e.target.value)}
                      InputLabelProps={{
                        shrink: true
                      }}
                      fullWidth
                      /> */}
                    <InputMask
                      label={t('birthday') + ' ' + t('eg_be')}
                      type='text'
                      id='date'
                      mask='99/99/9999'
                      maskChar='_'
                      alwaysShowMask
                      value={data.patient.dob === '00/00/0000' ? '' : data.patient.dob}
                      onChange={(e) => this.onTextChange('dob', e.target.value)}
                    >
                      {(inputProps) => (
                        <div>
                          <TextField
                            {...inputProps}
                            error={!data.reset ? this.state.errorField.dob : false}
                            className='birthdayControl'
                            fullWidth
                          />
                          <FormHelperText
                            error
                            hidden={!data.reset ? !this.state.errorField.dob : true}
                            id='component-error-text'
                          >
                            {this.state.errorReason.dob}
                          </FormHelperText>
                        </div>
                      )}
                    </InputMask>
                    {/* <FormHelperText error hidden={!data.reset ? !this.state.errorField.dob : true} id="component-error-text">{this.state.errorReason.dob}</FormHelperText> */}
                  </Fragment>
                )}
              </div>
            </Grid>
            <Grid item md={3} xs={6}>
              <div className={props.classes.formInput}>
                {data.patient && (
                  <Fragment>
                    <TextField
                      id='weight'
                      label={t('weight')}
                      value={data.patient.weight || ''}
                      onChange={(e) => this.validateInputChange('weight', e.target.value)}
                      onBlur={(e) => this.validateInputChange('weight', e.target.value)}
                      type='text'
                      fullWidth
                      InputProps={{
                        endAdornment: <InputAdornment position='end'>{t('kg')}</InputAdornment>,
                      }}
                      onInput={(e) => {
                        e.target.value = e.target.value.replace(/[^0-9.]/g, '');
                      }}
                    />
                  </Fragment>
                )}
              </div>
            </Grid>
            <Grid item md={3} xs={6}>
              <div className={props.classes.formInput}>
                {data.patient && (
                  <Fragment>
                    <TextField
                      id='height'
                      label={t('height')}
                      value={data.patient.height || ''}
                      onChange={(e) => this.validateInputChange('height', e.target.value)}
                      onBlur={(e) => this.validateInputChange('height', e.target.value)}
                      type='text'
                      fullWidth
                      InputProps={{
                        endAdornment: <InputAdornment position='end'>{t('cm')}</InputAdornment>,
                      }}
                      onInput={(e) => {
                        e.target.value = e.target.value.replace(/[^0-9.]/g, '');
                      }}
                    />
                  </Fragment>
                )}
              </div>
            </Grid>
            <Grid item md={6} xs={12}>
              <div className={props.classes.formInput}>
                {data.patient && (
                  <Fragment>
                    <TextField
                      select
                      className='inputBloodGroup'
                      label={t('blood_group')}
                      name='bloodGroup'
                      value={data.patient.bloodGroup || ''}
                      onChange={(e) => this.changeInfoData(e)}
                      fullWidth
                      SelectProps={{
                        native: true,
                      }}
                    >
                      <option value=''></option>
                      {bloodGroupList.map((val) => (
                        <option key={val} value={val}>
                          {val}
                        </option>
                      ))}
                    </TextField>
                  </Fragment>
                )}
              </div>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          {/* <Button onClick={this.props.handleClose} color="default">
            {t("cancel")}
          </Button>
          <Button onClick={this.handleSubmit} color="primary">
            {bed && bed.patient ? `${t("save")}` : `${t("admit")}`}
          </Button> */}
          <Grid
            container
            item
            style={{
              margin: '10px 28px',
              justifyContent: 'right',
            }}
          >
            <Button
              onClick={this.handleSubmit}
              color='primary'
              id='save'
              variant='contained'
              style={{
                width: 100,
              }}
            >
              {bed && bed.patient ? `${t('save')}` : `${t('admit')}`}
            </Button>
          </Grid>
        </DialogActions>
      </Dialog>
    );
  }
}

const styles = (theme) => ({
  chip: {
    fontSize: '0.9rem',
    fontWeight: '600',
    color: '#fff',
  },
});

export const page = inject('dashboard', 'patient', 'setting', 'bed')(observer(Patient));
export const translation = withTranslation()(page);
export default withStyles(styles, { withTheme: true })(translation);
